import * as React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import * as ApiCall from '../ApiCall.jsx';



export default function ConfirmOrderFooter({complete, total}) {

  const [state, setState] = React.useState('ordering');
  let cId = localStorage.getItem('customerId');
  
  function sendToKitchen() {
    setState('sending');
    ApiCall.post("/customers/send_order_to_kitchen", "customerId="+cId)
    .then((stuff) => {
      complete();
      setState('success');
    })
    .catch((msg) => {
      alert("Failed to confirm order, please try again:" + msg);
      setState('ordering');
    })

  }

  if (state === 'ordering') {
    return (
      <Box sx={{ mb: 3, mt: 2, minHeight: 1/5, width: 1, flexShrink: 0, backgroundColor: '#white', position: 'relative', bottom: 0, 
                  display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
        <Box sx={{ padding: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Typography variant="h6" sx={{fontWeight: "bold"}}>Total: ${total}</Typography>
          <Button variant="contained" sx={{fontSize: "1.1rem", p: 2, height: 0.4, textTransform: 'none', backgroundColor: "black", ':hover': {
                  color: 'white',
                  bgcolor: 'grey'
                }}} onClick={sendToKitchen}>Send order to kitchen</Button>
        </Box>
      </Box>
    )
  }

  else if (state === 'sending') {
    return (
      <Box sx={{ height: 1/5, width: 1, flexShrink: 0, backgroundColor: '#white', position: 'relative', bottom: 0, 
                  display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
        <CircularProgress />
      </Box>
    )
  }

  else if (state === 'success') {
    return (
      <Box sx={{ mb: 3, mt: 2, minHeight: 1/5, width: 1, flexShrink: 0, backgroundColor: '#white', position: 'relative', bottom: 0, 
        display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: 'center'}}>
        <Typography variant="h6"  align="center" sx={{p: 2, fontWeight: "bold"}}>Order has been sent, Thanks!</Typography>
        <Typography variant="body" align="center" sx={{p: 2}}>Feel free to add more dishes to a new order.</Typography>
      </Box>
    )
  }
}